<template>
  <div>
    <form class="topform" @submit="sendEmail($event)">
      <div style="margin-bottom:10px;">
        <label>Wybierz użytkownika:</label>
        <select class="form-control" id="select" v-model="selectedUser">
          <option
            :value="data.user_profile.user.id"
            v-for="data in this.users.data.user_profile_service"
            :key="data.user_profile.user.id"
          >
            {{ data.user_profile.profile.first_name }}
            {{ data.user_profile.profile.last_name }}
          </option>
        </select>
      </div>

      <p>
        <label>Wiadomość:</label>
        <textarea
          :disabled="!selectedUser"
          id="body"
          rows="5"
          maxlength="6000"
          minlength="1"
          v-model="message"
          class="form-control"
          required
          style="width: 100% "
          ref="my_input"
        ></textarea>
      </p>
      <button class="buttonm btn btn-outline-dark" type="submit">Wyślij</button>
    </form>
    <p v-if="infoMessage.message" class="text-succes">
      {{ infoMessage.message }}
    </p>
  </div>
</template>

<script>
export default {
  name: "send-email",
  computed: {
    users() {
      return this.$store.getters.getUsersWithoutPagination;
    },
    infoMessage() {
      return this.$store.getters.getNotificationResponse;
    },
  },
  created() {
    this.$store.dispatch("getProfilesWithoutPagination");
  },
  data: function() {
    return {
      selectedUser: "",
      message: "",
    };
  },
  methods: {
    sendEmail(e) {
      e.preventDefault();
      let body = {
        message: this.message,
        url: `/api/admin/send-email-to-user/${this.selectedUser}?message=${this.message}`,
      };
      this.$store.dispatch("sendUsersEmail", body);
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
button.btn {
  margin-top: 20px;
}
.topform {
  display: flex;
  flex-direction: column;
}
.topform button {
  width: 100%;
}
</style>
